/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { auth } from "../../firebase";

import Input from "../UI/Input/Input";
import Error from "../UI/Error/Error";
import classes from "./PasswordReset.module.css";

const Form = ({ onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [resetError, setResetError] = useState(false);

  const onSubmit = (data) => {
    console.log(data);
    auth
      .sendPasswordResetEmail(data.email)
      .then(() => {
        onSuccess(data.email);
      })
      .catch((error) => {
        console.log(error);
        if (error.code === "auth/user-not-found") {
          setResetError(true);
        }
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          type="email"
          placeholder="Input your email"
          error={errors.email ? "error" : null}
          {...register("email", {
            required: true,
            pattern:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          })}
        />
        {errors.email && errors.email.type === "pattern" ? (
          <Error className={classes.Error}>
            Please enter a valid email address.
          </Error>
        ) : null}
        {errors.email && errors.email.type === "required" ? (
          <Error className={classes.Error}>This field is required.</Error>
        ) : null}
        {resetError ? (
          <Error className={classes.ResetError}>
            The entered email address is not associated with any account.
          </Error>
        ) : null}
        <button type="submit">Reset password</button>
      </form>
    </>
  );
};

export default Form;
